import { render } from "./ImageDiff.vue?vue&type=template&id=3de49833&scoped=true"
import script from "./ImageDiff.vue?vue&type=script&lang=js"
export * from "./ImageDiff.vue?vue&type=script&lang=js"

import "./ImageDiff.vue?vue&type=style&index=0&id=3de49833&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de49833"]])

export default __exports__